







import {defineComponent, PropType} from "@vue/composition-api";
import AppLayout from "@tool/Layouts/AppLayout.vue";
import Todo from "@tool/Components/Todo.vue";
import Breadcrumbs from "@tool/Components/Breadcrumbs.vue";
import {CrumbPage, ProjectEntityInterface} from "@tool/tool.types";


export default defineComponent({
    components: {
        Breadcrumbs,
        Todo,
        AppLayout,
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        },
        name: {
            type: String,
            required: true,
        },
        extraBreadcrumbs: {
            type: Array as PropType<CrumbPage[]>,
            required: false,
            default: () => []
        }
    },
    setup(props, {slots}) {
        const hasTopRightSlot = slots.top_right;

        const breadcrumbPages: CrumbPage[] = [
            ...props.extraBreadcrumbs,
            {name: props.name}
        ]

        return {
            hasTopRightSlot,
            breadcrumbPages
        }
    }
})
